module.exports = __webpack_public_path__ + "static/media/logo_white.17a7fbf9.png";